import { create } from 'zustand';
import { AlertVariantType } from '@src/constants/AlertVariantType';

export type AlertState = {
  title: string | null;
  variant: string;
  visible: boolean;
  message: string | null;
  isPermanent?: boolean | null;
  link?: {
    text: string;
    url: string;
    openNewTab?: boolean;
  };
  messageAfterLink?: string;
};

interface AlertStoreState {
  alertState: {
    title: string | null;
    variant: string;
    visible: boolean;
    message: string | null;
  };
  showAlert: (alertState: AlertState) => void;
}

export const useAlertStore = create<AlertStoreState>((set) => {
  return {
    alertState: {
      title: null,
      variant: AlertVariantType.ERROR,
      visible: false,
      message: '',
    },
    showAlert: (alertState: AlertState) => {
      return set(() => {
        return { alertState };
      });
    },
  };
});
